import { render, staticRenderFns } from "./BaseComplexField.vue?vue&type=template&id=0a5dcb15&"
import script from "./BaseComplexField.vue?vue&type=script&lang=js&"
export * from "./BaseComplexField.vue?vue&type=script&lang=js&"
import style0 from "./BaseComplexField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
